const subscriptionFeatures = {
  title: 'Features included',
  columns: [
    ['NLP-powered search (rankings, queries)', 'Player profiles', 'Player team data'],
    ['Game dashboard', 'Record books*'],
    ['Graphics & Charts', 'Dashboards'],
  ],
};

export default subscriptionFeatures;

